import * as types from './templates.types';

export const templatesPageSelectors: types.ITemplatePageSelectors = {
  selectTemplateIds: (state) => state.page.templates.templateIds,
};
